import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import { ReactComponent as IconMenu } from "assets/icons/align-justify.svg";
import { ReactComponent as IconCloseMenu } from "assets/icons/close.svg";
import ImgLogo from "assets/images/imgHeader/logo.png";
import { UrlInternal } from "common/constants/endpoints";
import { deleteLocaStorage, getLocalStorage } from "utils/localStorage";
import { GETME } from "utils/localStorage/type";
import * as S from "./style";
import moment from "moment";
import { initForFetchEventSource } from "apis/fetchEventSource";
import useWindowSize, { Size } from "hooks/useWindowSize";
import { useSelector } from "react-redux";
import { formatPrice } from "utils/formatPrice";
import { logoutApi } from "apis/auth";
interface Props {
  children?: any;
  noImageHeader?: boolean;
  type?: "smallBanner" | "default";
  typeContent?: "out" | "in";
}

const listSubGpMobile = [
  {
    title: "청약/ 공동구매",
    url: UrlInternal.GROUP_SALE_LIST,
  },
];

const TemplateMypage = ({
  children,
  type = "default",
  typeContent = "in",
}: Props) => {
  const history = useHistory();
  const path = window.location.pathname;
  const dataMe = getLocalStorage(GETME, 0);

  const [visibleMenuMobile, setVisibleMenuMobile] = useState<boolean>(true);
  const [miniMenuNumber, setMiniMenuNumber] = useState<number>();
  const [isScroll, setScrollStatus] = useState<any>(false);
  const size: Size = useWindowSize();
  const isMobile = size.width && size.width <= 1023;
  const { dataShinhan } = useSelector((state: any) => state.dataShinhan);
  const [webMenuAtive, setWebMenuAtive] = useState<boolean>(false);
  const isMaintenance = false;

  const mainMenu = [
    {
      title: "증권청약",
      pathName: UrlInternal.PATHNAME_GROUP_SALE,
      menu: "menu_2",
      childURL: [
        UrlInternal.GROUP_SALE_GENERAL_PURCHASE_SCHEDULE,
        UrlInternal.GROUP_SALE_LIST,
        UrlInternal.GROUP_SALE_ON_ORDER_CONFIRM,
        UrlInternal.GROUP_SALE,
        UrlInternal.OWNERSHIP,
        UrlInternal.PURCHASE_SUMMARY,
      ],
    },
    {
      title: "마켓인사이트",
      pathName: UrlInternal.INSIGHT,
      menu: "menu_6",
      childURL: [
        UrlInternal.NEWS_LETTER_LIST,
        UrlInternal.ART_INSIGHT,
        UrlInternal.TEMP,
      ],
    },
    {
      title: "고객센터",
      pathName: UrlInternal.PATHNAME_CUSTOM_SERVICE,
      menu: "menu_4",
      childURL: [
        UrlInternal.PUBLIC_NOTICE,
        UrlInternal.ANNOUCEMENT,
        UrlInternal.GROUP_SALE_GUIDE_CUSTOMER_SERVICE_STEP,
        UrlInternal.QUESTION,
      ],
    },
    {
      title: dataMe
        ? isMobile
          ? "마이페이지"
          : `${dataMe?.displayName} 님`
        : "로그인",
      pathName: UrlInternal.LOGIN,
      menu: dataMe ? "menu_5" : "menu_7",
      ...(dataMe && {
        childURL: [
          UrlInternal.MYPAGE_BUY_TOGETHER_HISTORY,
          UrlInternal.MYPAGE_FAQ_HISTORY,
          UrlInternal.MYPAGE_MYACCOUNT,
          UrlInternal.LOGIN,
        ],
      }),
    },
  ];

  const subMenu = {
    menu_2: [
      {
        id: 1,
        name: "청약 캘린더",
        url: `${UrlInternal.GROUP_SALE_GENERAL_PURCHASE_SCHEDULE}`,
        link: `${UrlInternal.GROUP_SALE_GENERAL_PURCHASE_SCHEDULE}`,
      },
      {
        id: 3,
        name: "증권청약",
        url: `${UrlInternal.GROUP_SALE_LIST}`,
        link: `${UrlInternal.GROUP_SALE_LIST}`,
      },

      {
        id: 5,
        name: "매각현황",
        url: `${UrlInternal.PURCHASE_SUMMARY}`,
        link: `${UrlInternal.PURCHASE_SUMMARY}`,
      },
    ],
    menu_4: [
      {
        id: 22,
        name: "공시",
        url: `${UrlInternal.PUBLIC_NOTICE}`,
        link: `${UrlInternal.PUBLIC_NOTICE}`,
      },
      {
        id: 10,
        name: "공지사항",
        url: `${UrlInternal.ANNOUCEMENT}`,
        link: `${UrlInternal.ANNOUCEMENT}`,
      },
      {
        id: 11,
        name: "이용가이드",
        url: `${UrlInternal.GROUP_SALE_GUIDE_CUSTOMER_SERVICE_STEP}`,
        link: `${UrlInternal.GROUP_SALE_GUIDE_CUSTOMER_SERVICE_STEP}`,
      },
      {
        id: 12,
        name: "자주묻는질문",
        url: `${UrlInternal.QUESTION}`,
        link: `${UrlInternal.QUESTION}`,
      },
    ],
    menu_5: [
      {
        id: 15,
        name: "증권청약 내역",
        url: `${UrlInternal.MYPAGE_BUY_TOGETHER_HISTORY}`,
        link: `${UrlInternal.MYPAGE_BUY_TOGETHER_HISTORY}`,
      },
      {
        id: 18,
        name: `1\u200B:\u200B1 문의사항`,
        url: `${UrlInternal.MYPAGE_FAQ_HISTORY}`,
        link: `${UrlInternal.MYPAGE_FAQ_HISTORY}`,
      },
      {
        id: 14,
        name: "나의 계정",
        url: `${UrlInternal.MYPAGE_MYACCOUNT}`,
        link: `${UrlInternal.MYPAGE_MYACCOUNT}`,
      },
      ...(!isMobile
        ? [
            {
              id: 21,
              name: "로그아웃",
              url: `${UrlInternal.LOGIN}`,
              link: `${UrlInternal.LOGIN}`,
            },
          ]
        : []),
    ],
    menu_6: [
      {
        id: 13,
        name: "뉴스레터",
        url: `${UrlInternal.NEWS_LETTER_LIST}`,
        link: `${UrlInternal.NEWS_LETTER_LIST}`,
      },
      {
        id: 22,
        name: "Research",
        url: `${UrlInternal.TEMP}`,
        link: `${UrlInternal.TEMP}`,
      },
      {
        id: 19,
        name: "아트인사이드",
        url: `${UrlInternal.ART_INSIGHT}`,
        link: `${UrlInternal.ART_INSIGHT}`,
      },
    ],
  };

  useEffect(() => {
    if (visibleMenuMobile) {
      document.body.style.overflowY = "auto";
      document.body.setAttribute("style", "-ms-touch-action: auto;");
    } else {
      document.body.style.overflowY = "hidden";
      document.body.setAttribute("style", "-ms-touch-action: none;");
    }
  }, [visibleMenuMobile]);

  const openWebMenu = () => {
    setWebMenuAtive(true);
  };

  const closeWebMenu = () => {
    setWebMenuAtive(false);
  };

  const openMenu = () => {
    setVisibleMenuMobile(!visibleMenuMobile);
  };

  const openMiniMenu = (e: any, index: number) => {
    if (miniMenuNumber === -1) {
      setMiniMenuNumber(index);
    } else {
      setMiniMenuNumber(-1);
    }
  };

  const onLogout = async () => {
    if (dataMe) {
      try {
        const resp: any = await logoutApi();

        if (resp.result) {
        }
      } catch (error) {}
    }

    deleteLocaStorage(GETME);
    history.push(UrlInternal.LOGIN);
    setVisibleMenuMobile(!visibleMenuMobile);
    initForFetchEventSource("", true);
    window?.qg("event", "logout", {
      user_code: dataMe?.id,
      user_id: dataMe?.userName,
      logout_type: dataMe?.accountType,
      logout_date: moment().format("YYYY-MM-DD"),
    });
  };

  const handelLogo = () => {
    window.scrollTo(0, 0);
    history.push(UrlInternal.HOME);
  };

  const handleActiveChildren = (childURL: any, pathName: string) => {
    if (!childURL && pathName !== UrlInternal.LOGIN) {
      return path === pathName || path.includes(pathName) ? "child-live" : "";
    } else {
      return childURL?.some((element: any) => path.includes(element))
        ? "menu__item-active"
        : "";
    }
  };

  const handleSubMenu = (string: keyof typeof subMenu) => {
    const Item = subMenu[string]?.map((item: any, index: number) => (
      <S.MenuListMini
        key={index}
        className={`item__menu-sub-mobile ${
          path.includes(item.link) ? "active" : ""
        } ${
          item.url === UrlInternal.OWNERSHIP && isMobile
            ? "item__menu-sub-mobile__hidden"
            : ""
        }`}
        onClick={() => {
          if (item?.id !== 21) {
            if (isMobile) {
              if (item.url !== UrlInternal.GROUP_SALE_LIST) {
                if (
                  [
                    UrlInternal.MYPAGE_MYACCOUNT,
                    UrlInternal.MYPAGE_BUY_TOGETHER_HISTORY,
                    UrlInternal.GROUP_SALE_GENERAL_PURCHASE_SCHEDULE,
                  ].includes(item.url)
                ) {
                  window.location.href = item.url;
                } else {
                  history.push(item.url);
                  setVisibleMenuMobile(true);
                }
              }
            } else {
              if (
                [
                  UrlInternal.GROUP_SALE_LIST,
                  UrlInternal.MYPAGE_BUY_TOGETHER_HISTORY,
                  UrlInternal.GROUP_SALE_GENERAL_PURCHASE_SCHEDULE,
                ].includes(item.url)
              ) {
                window.location.href = item.url;
              } else {
                history.push(item.url);
                setVisibleMenuMobile(true);
              }
            }
          }
        }}
      >
        {item.name}
        {item.url === UrlInternal.GROUP_SALE_LIST && isMobile && (
          <div className="box-mobile-sub-gp">
            {listSubGpMobile?.map((dt, i) => (
              <div
                key={i}
                className={path === dt.url ? "box-mobile-sub-gp__active" : ""}
                onClick={() => {
                  if (
                    [
                      UrlInternal.GROUP_SALE_LIST,
                      UrlInternal.GROUP_SALE_GENERAL_PURCHASE_SCHEDULE,
                    ].includes(dt.url)
                  ) {
                    window.location.href = dt.url;
                  } else {
                    history.push(dt.url);
                    setVisibleMenuMobile(true);
                  }
                }}
              >
                - {dt.title}
              </div>
            ))}
          </div>
        )}
      </S.MenuListMini>
    ));
    return Item;
  };

  return (
    <>
      <S.Container active={isScroll}>
        <S.Logo>
          <img
            className="item-logo"
            src={ImgLogo}
            alt="img logo"
            onClick={handelLogo}
          />

          <S.ContainerRightMobile active={isScroll}>
            {visibleMenuMobile ? (
              <IconMenu onClick={openMenu} />
            ) : (
              <IconCloseMenu onClick={openMenu} />
            )}
          </S.ContainerRightMobile>
          <S.MenuList active={isScroll}>
            <div
              className="subMenuLayer"
              onMouseLeave={closeWebMenu}
              style={{ display: webMenuAtive ? "block" : "none" }}
            ></div>
            {mainMenu.map((data: any, index) => {
              return (
                <S.Menu
                  onMouseEnter={openWebMenu}
                  className={`menu__item ${handleActiveChildren(
                    data?.childURL,
                    data.pathName
                  )}`}
                  active={data?.childURL?.some((element: any) =>
                    path.includes(element)
                  )}
                  key={index}
                  onClick={() => {
                    if (!data?.childURL) {
                      history.push(data.pathName);
                    }
                  }}
                >
                  <div
                    style={
                      data.menu === "menu_5" || data.menu === "menu_7"
                        ? { fontWeight: "bolder", color: "#653cd5" }
                        : {}
                    }
                    className={"menu__item-title"}
                  >
                    {data.title}
                    {data?.childURL?.length > 0 ? (
                      <S.SubMenuBox
                        style={{ display: webMenuAtive ? "block" : "none" }}
                        active={isScroll}
                      >
                        {Object.entries(subMenu).map(([key, value]) =>
                          value.map(
                            (item: any, index: number) =>
                              key === data.menu && (
                                <div
                                  key={`${key}_${index}`}
                                  className="subMenu"
                                >
                                  {item.id === 21 ? (
                                    <a onClick={onLogout}>{item.name}</a>
                                  ) : (
                                    <a href={item.url}>{item.name}</a>
                                  )}
                                </div>
                              )
                          )
                        )}
                        {data.menu === "menu_5" && dataMe && (
                          <>
                            {dataShinhan?.balance >= 0 ? (
                              <div className="value">
                                {isMaintenance
                                  ? "증권 계좌 잔액 : 증권사 점검중"
                                  : "증권 계좌 잔액 : " +
                                    formatPrice(dataShinhan?.balance) +
                                    "원"}
                              </div>
                            ) : (
                              <S.Btn2
                                onClick={() =>
                                  history.push(
                                    UrlInternal.MYPAGE_MYACCOUNT_SHINHAN,
                                    {
                                      isRegister: true,
                                    }
                                  )
                                }
                              >
                                증권계좌개설
                              </S.Btn2>
                            )}
                          </>
                        )}
                      </S.SubMenuBox>
                    ) : null}
                  </div>
                </S.Menu>
              );
            })}
          </S.MenuList>
        </S.Logo>

        <S.WrapperMenuMobile active={isScroll} isShow={!visibleMenuMobile}>
          {dataMe && (
            <S.WrapperUserMobile>
              <S.MobileUser>
                <S.MobileUserName>{dataMe?.displayName} 님</S.MobileUserName>
              </S.MobileUser>
              {dataShinhan?.balance >= 0 ? (
                <div className="linked-account">
                  {isMaintenance
                    ? "내 잔고 : 증권사 점검중"
                    : "내 잔고 : " + formatPrice(dataShinhan?.balance) + "원"}
                </div>
              ) : (
                <S.Btn2Mobile
                  type="button"
                  onClick={() =>
                    history.push(UrlInternal.MYPAGE_MYACCOUNT, {
                      isRegister: true,
                    })
                  }
                >
                  {isMaintenance ? "증권사 점검중" : "증권계좌개설"}
                </S.Btn2Mobile>
              )}
            </S.WrapperUserMobile>
          )}
          <S.MenuMobileBox>
            {mainMenu
              .filter((data: any) => dataMe || data.menu !== "menu_7")
              .map((data: any, index) => (
                <S.MenuMobile
                  key={index}
                  onClick={(e) => {
                    if (!data?.childURL) {
                      history.push(data.pathName);
                    } else {
                      openMiniMenu(e, index);
                    }
                  }}
                  active={data?.childURL?.some((element: any) =>
                    path.includes(element)
                  )}
                  isHide={!dataMe}
                  className={
                    !data?.childURL &&
                    (path === data.pathName || path.includes(data.pathName))
                      ? "menu-active"
                      : ""
                  }
                >
                  {data.title}
                  {miniMenuNumber === index && (
                    <div className="item__menu">{handleSubMenu(data.menu)}</div>
                  )}
                </S.MenuMobile>
              ))}
          </S.MenuMobileBox>
          <S.MenuMobileButton>
            <S.ExportButton onClick={onLogout}>
              {dataMe ? "로그아웃" : "로그인"}
            </S.ExportButton>
          </S.MenuMobileButton>
        </S.WrapperMenuMobile>
      </S.Container>
      {type === "smallBanner" && <S.SmallBanner></S.SmallBanner>}
      {typeContent === "in" ? (
        <S.ContentBody>{children}</S.ContentBody>
      ) : (
        children
      )}
    </>
  );
};

export default TemplateMypage;
